import React, { useEffect, useState } from "react";
import MarketHeroCard from "./MarketHeroCard";
import { poweredBy, tick } from "./svgs";

interface MarketSearchPageProps {
  query: string;
  userInfo: any;
  setQuery: (query: string) => void;
  submit: () => void;
  setHeight: (height: number) => void
}

const MarketLandingPage: React.FC<MarketSearchPageProps> = ({
  query,
  userInfo,
  setQuery,
  submit,
  setHeight
}) => {
  const [searchFocus, setSearchFocus] = useState(false);
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    setHeight(650)
  },[])

  const handleInputChange = async (e: any) => {
    e.preventDefault();
    setQuery(e.target.value);
  };

  const handleClick = () => {
    if(animate) return
    setAnimate(true);
    setTimeout(() => setAnimate(false), 750); // This will remove the class after the animation completes
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    submit();
  };

  let widthStyle = "100%"; // default

  if (navigator.userAgent.includes("Firefox")) {
    widthStyle = "-moz-available";
  } else if (
    navigator.userAgent.includes("Chrome") ||
    navigator.userAgent.includes("Safari")
  ) {
    widthStyle = "-webkit-fill-available";
  } else {
    widthStyle = "fill-available";
  }

  const pageStyle: React.CSSProperties = {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    width: widthStyle,
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
  };

  const formStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: widthStyle,
    gap: 10,
  };

  const topStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: widthStyle,
    color: "#FFFFFF",
    padding: 30,
    fontSize: "32px",
    gap: 20,
    zIndex: 0,
    overflow: "hidden",
    background: "linear-gradient(151.11deg, #854EFB 17.78%, #5709FF 104.86%)",
  };

  const bottomStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 20,
    paddingBottom: 24,
    paddingRight: 30,
    paddingLeft: 30,
    backgroundColor: "rgba(248, 248, 248, 1)",
    gap: 20,
    width: widthStyle,
    fontSize: "14px",
    zIndex: 2,
  };

  const searchButtonStyle: React.CSSProperties = {
    paddingTop: 4,
    cursor: "pointer",
    height: 48,
    background: "linear-gradient(108.64deg, #854EFB 7.51%, #8A88FF 98.44%)",
    boxShadow:
      "0px 122.973px 98.3784px rgba(0, 0, 0, 0.07), 0px 51.3752px 41.1001px rgba(0, 0, 0, 0.0503198), 0px 27.4676px 21.9741px rgba(0, 0, 0, 0.0417275), 0px 15.3981px 12.3185px rgba(0, 0, 0, 0.035), 0px 8.17783px 6.54226px rgba(0, 0, 0, 0.0282725), 0px 3.40298px 2.72238px rgba(0, 0, 0, 0.0196802)",
    borderRadius: 12,
    border: "1.5px solid #8A88FF",
    color: "#FFFFFF",
    width: widthStyle,
  };

  const searchInputStyle = (hasFocus: boolean): React.CSSProperties => ({
    display: "flex",
    height: 48,
    background: "#FFFFFF",
    borderColor: "#FFFFFF",
    outline: "none",
    border: hasFocus ? "1.5px solid #8A88FF" : "1.5px solid #FFFFFF",
    fontFamily: "GT Planar Regular",
    fontSize: "24px",
    color: "rgb(30, 29, 29)",
    boxShadow:
      "0px 109px 230px rgba(38, 14, 110, 0.2), 0px 45.5376px 96.0885px rgba(38, 14, 110, 0.143771), 0px 24.3466px 51.3735px rgba(38, 14, 110, 0.119221), 0px 13.6485px 28.7996px rgba(38, 14, 110, 0.1), 0px 7.24861px 15.2952px rgba(38, 14, 110, 0.0807786), 0px 3.01631px 6.36469px rgba(38, 14, 110, 0.0562291)",
    borderRadius: 12,
    width: widthStyle,
    paddingLeft: 10,
    margin: 0,
  });

  return (
    <div style={pageStyle}>
      <div style={topStyle}>
        <div>
          Get Your Web3 <br />
          Username
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 5,
            fontSize: "16px",
            fontFamily: "GT Planar Regular",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 10,
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {tick} Name your {userInfo.walletAddress.substring(0, 12)}...address
          </div>
          <div
            style={{
              display: "flex",
              gap: 10,
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {tick} Send and receive more easily
          </div>
          <div
            style={{
              display: "flex",
              gap: 10,
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {tick} Claim your web3 identity
          </div>
        </div>
        <div onClick={handleClick} style={{ position: "relative", zIndex: 1 }} >
          <MarketHeroCard
            domain={"nora.miller"}
            avatarUrl={
              "https://assets.superlink.me/avatar/avatar_f7617e26-8a28-45f7-be40-9f3578cd514d.jpeg"
            }
            walletAddress={userInfo.walletAddress}
            backgroundUrl="https://assets.superlink.me/backgrounds/58d9d9ef-313b-4e81-8908-cc23bb251bfa"
            containerStyle={{
              transform: "rotate(9deg)",
              left: -10,
              top: 50,
              width: 350,
              height: 350,
              animation: animate ?'wiggle 0.25s linear infinite': '',
              transition: "transform 1ms linear all"
            }}
          />
        </div>
      </div>

      <div style={bottomStyle}>
        <form onSubmit={handleSubmit} style={formStyle}>
          <div
            style={{
              textAlign: "left",
              width: "-webkit-fill-available",
              color: "rgba(0, 0, 0, 0.7)",
              fontSize: "16px",
            }}
          >
            Search your name
          </div>

          <input
            type="text"
            onChange={handleInputChange}
            placeholder={userInfo.fullName || "Nora Miller"}
            value={query}
            style={searchInputStyle(searchFocus)}
            onFocus={() => setSearchFocus(true)}
            onBlur={() => setSearchFocus(false)}
          />
          <button type="submit" style={searchButtonStyle}>
            Get your name
          </button>
        </form>
        {poweredBy}
      </div>
    </div>
  );
};

export default MarketLandingPage;
